
import { IAPICompany } from '@hokify/common';
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { locationCount, getLocationText } from '../../helpers/company-getter';

export default defineComponent({
	name: 'Location',
	data() {
		return {
			locationCount,
			getLocationText
		};
	},
	computed: {
		locationCountForCompany(): number {
			return this.locationCount(this.company) || 0;
		}
	},
	props: {
		company: { type: Object as PropType<IAPICompany>, required: true },
		size: {
			type: String,
			default: 'normal',
			validator: (value: string) => ['small', 'normal'].includes(value)
		}
	}
});
